import React, {useState} from "react";
import {FolderOpenOutlined} from "@ant-design/icons";
import { Table, Typography, Modal, Spin, Form, Tooltip, Button } from "antd";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Period Type",
    dataIndex: "periodType",
  },
  {
    title: "Period From / To",
    dataIndex: "periodFromTo",
  },
  {
    title: "Amount Range",
    dataIndex: "amountRange",
  },
  {
    title: "Interest",
    dataIndex: "interest",
  },
  {
    title: "Actions",
    render: (_, record) => (
      <>
        <IncentivesModal
          transactionObj={record}
        />
      </>
    ),
  },
];

const InterestRateChart = (props) => {
  const { interestRateChartList } = props;
  return <Table columns={columns} dataSource={interestRateChartList} />;
};

export default InterestRateChart;

const IncentivesModal = (props) => {
  // const { currentCustomerObj, userData, transactionObj } = props;

  // const { session } = userData;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [transactionsDetail, setTransactionsDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      title: "Attribute",
      dataIndex: "attribute",
    },
    {
      title: "Condition",
      dataIndex: "condition",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Value",
      dataIndex: "value",
    },
    {
      title: "Interest",
      dataIndex: "interest",
    },
  ];

  // const getDetailById = () => {
  //   setIsLoading(true);

  //   const url = `${apiConfig.FixedDepositAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

  //   let body = {
  //     session,
  //   };

  //   /** FETCH ROLE */
  //   BOM.FetchReqAction(body, url, (err, res) => {
  //     if (err) {
  //       BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
  //       setIsLoading(false);
  //     } else {
  //       const objDetail = res;
  //       setTransactionsDetail(objDetail);

  //       setIsLoading(false);
  //     }
  //   });
  // };


  const showModal = () => {
    setIsModalOpen(true);
    // getDetailById();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip title={`View Incentives`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Incentives"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
          <Table columns={columns} 
          // dataSource={interestRateChartList} 
          />
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
